import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UtenteService } from '../../../../lib/services/utente.service';

declare var $: any;

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.sass'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class LogoutComponent implements OnInit {
  private router = inject(Router);
  private utenteService = inject(UtenteService);


  ngOnInit(): void {
    // Il logout cambia la sessione nel ciclo successivo, dopo che Angular ha
    // completato il controllo del componente creato dalla rotta /logout.
    setTimeout(() => {
      void this.utenteService.logout();
      void this.router.navigate(['/']);
    });
  }

}
